import React, { useState } from 'react';
import { Form, Input, Button, Table, Card, Row, Col, message } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Trans } from '@lingui/macro';

const PublicDdsSearch = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 15,
        total: 0,
    });

    React.useEffect(() => {
        handleSearch({}, 1, 15);
    }, []);

    const handleSearch = async (values: any, page: number = 1, pageSize: number = 15) => {
        setLoading(true);
        try {
            const requestBody: any = {
                start: page - 1,
                length: pageSize,
                direction: 'DESC',
                sorted_field: 'id'
            };
            
            if (values.invoiceNo || values.deliveryNoteNumber) {
                requestBody.query = {};
                if (values.invoiceNo) {
                    requestBody.query.invoiceNo = values.invoiceNo;
                }
                if (values.deliveryNoteNumber) {
                    requestBody.query.deliveryNoteNumber = values.deliveryNoteNumber;
                }
            }

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/public/dds-assignments/search`, requestBody);
            
            setData(response.data.data);
            setPagination({
                current: page,
                pageSize: pageSize,
                total: response.data.recordsFiltered,
            });
        } catch (error) {
            message.error('Search failed. Please check your inputs and try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleTableChange = (newPagination: any) => {
        const values = form.getFieldsValue();
        handleSearch(values, newPagination.current, newPagination.pageSize);
    };

    const handleExport = async () => {
        const values = form.getFieldsValue();

        console.log('sdasd');
        try {
            const requestBody: any = {};
            if (values.invoiceNo) {
                requestBody.invoiceNo = values.invoiceNo;
            }
            if (values.deliveryNoteNumber) {
                requestBody.deliveryNoteNumber = values.deliveryNoteNumber;
            }

            const response = await
                axios
                    .get(
                        process.env.REACT_APP_API_BASE_URL + '/public/dds-assignments/xls?invoiceNo='
                + (values.invoiceNo === 'undefined' ? '' : values.invoiceNo)
                + "&deliveryNoteNumber="
                + (values.deliveryNoteNumber === 'undefined' ? '' : values.deliveryNoteNumber),
                {responseType: 'blob'}
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'dds_assignments.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            message.error('Export failed.');
        }
    };

    const columns = [
        {
            title: <Trans>DDS Number</Trans>,
            dataIndex: 'ddsNumber',
            key: 'ddsNumber',
        },
        {
            title: <Trans>Valid From</Trans>,
            dataIndex: 'ddsNumberValidFrom',
            key: 'ddsNumberValidFrom',
        },
        {
            title: <Trans>Valid To</Trans>,
            dataIndex: 'ddsNumberValidTo',
            key: 'ddsNumberValidTo',
        },
        {
            title: <Trans>Invoice No</Trans>,
            dataIndex: 'invoiceNo',
            key: 'invoiceNo',
        },
        {
            title: <Trans>Delivery Note Number</Trans>,
            dataIndex: 'deliveryNoteNumber',
            key: 'deliveryNoteNumber',
        },
        {
            title: <Trans>ItemNo</Trans>,
            dataIndex: 'itemNo',
            key: 'itemNo',
        },
        {
            title: <Trans>Tarric Code / CN Code</Trans>,
            dataIndex: 'tarricCode',
            key: 'tarricCode',
        },
        {
            title: <Trans>Quantity</Trans>,
            dataIndex: 'quantity',
            key: 'quantity',
        },
    ];

    return (
        <div style={{ padding: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f2f5' }}>
            <Card title={<Trans>DDS Assignment Search</Trans>} style={{ width: '100%', maxWidth: 1200 }}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => handleSearch(values, 1, pagination.pageSize)}
                >
                    <Row gutter={16}>
                        <Col span={10}>
                            <Form.Item
                                name="invoiceNo"
                                label={<Trans>Invoice Number</Trans>}
                            >
                                <Input placeholder="Invoice Number" />
                            </Form.Item>
                        </Col>
                        <Col span={10}>
                            <Form.Item
                                name="deliveryNoteNumber"
                                label={<Trans>Delivery Note Number</Trans>}
                            >
                                <Input placeholder="Delivery Note Number" />
                            </Form.Item>
                        </Col>
                        <Col span={4} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '24px' }}>
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading} block>
                                <Trans>Search</Trans>
                            </Button>
                        </Col>
                    </Row>
                </Form>

                <div style={{ marginBottom: 16, textAlign: 'right' }}>
                    <Button icon={<DownloadOutlined />} onClick={handleExport}>
                        <Trans>Export to Excel</Trans>
                    </Button>
                </div>

                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    loading={loading}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        pageSizeOptions: ["5", "10", "15", "20", "50", "100"],
                    }}
                    onChange={handleTableChange}
                />
            </Card>
        </div>
    );
};

export default PublicDdsSearch;
